import React from 'react'
import { createTableStore, type TableStore, type TableStoreAndActions } from './tanstack-table-instance.store'
import { useStore } from 'zustand'

export const TableContext = React.createContext<TableStore | null>(null)

export const TableProvider = ({ children, rowKey }: { rowKey: string; children: React.ReactNode }) => {
    const storeRef = React.useRef<TableStore>()
    if (!storeRef.current) {
        storeRef.current = createTableStore(rowKey)
    }
    return <TableContext.Provider value={storeRef.current}>{children}</TableContext.Provider>
}

export function useTableContext<T>(selector: (state: TableStoreAndActions) => T): T {
    const store = React.useContext(TableContext)
    if (!store) {
        console.error('Missing TableContext.Provider in the tree')
        throw new Error('Missing TableContext.Provider in the tree')
    }

    return useStore(store, selector)
}
